import styled from 'styled-components';

export const Download = styled('a')`
  display: flex;
  height: 40px;
  min-width: 150px;
  line-height: 35px;
  border-radius: 6px;
  background-image: linear-gradient(to bottom, #5b8fe5, #4779cb 99%);
  padding: 0 15px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  color: #fff !important;
  transition: background-image 0.3s;
  white-space: nowrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 10px 20px -10px rgba(0, 0, 0, 0.3);

  &:hover {
    background-image: linear-gradient(to bottom, #619cff, #558ce6);
  }

  &:active {
    background-image: linear-gradient(to bottom, #578adf, #406cb5 99%);
  }
`;
